import React, { useState } from "react";
import { Row, Col, Button, InputGroup, Form } from "react-bootstrap";
import { ActionHandlerFunction, PaginationItem } from "@preveil-api";
import { DriveUIActionTypes } from "src/common";
import { Icon, Pagination, PaginationDisplay } from "src/components";

type AllProps = {
  // watched_logs?: WatchedLogEntity[];
  is_loading: boolean;
  pagination?: PaginationItem;
  handleAction: ActionHandlerFunction;
}

function ToolbarComponent(props: AllProps) {
  const { is_loading, pagination, handleAction } = props;
  const [filter_param, setFilterParam] = useState<string>("");

  // Description: reset filters on pagination and on click of x
  function resetFilters() {
    setFilterParam("");
    handleAction({ actionType: DriveUIActionTypes.Filter, params: "" });
  }

  return <Row className="toolbar watched">
    {
      <>
        <Col xs="auto" className="ps-0 ms-1 col-sm-5">
          <InputGroup size="sm">
            <InputGroup.Text>
              <Icon className="ficon-filter" />
            </InputGroup.Text>
            <Form.Control
              id="filter_tb"
              size="sm"
              autoComplete="off"
              disabled={is_loading}
              value={filter_param}
              onChange={(e) => {
                setFilterParam(e.target.value);
                handleAction({ actionType: DriveUIActionTypes.Filter, params: e.target.value });
              }}
              type="text"
              placeholder="Filter by items name in this page..."
              aria-label="Filter" />
            {
              filter_param &&
              <Button
                variant="icon"
                size="sm"
                className="input-group-btn"
                onClick={resetFilters} >
                <Icon className="ficon-x-circle" />
              </Button>
            }
          </InputGroup>
        </Col>

        <Col xs="auto" className="order-sm-2 order-3 ms-auto">
          {
            !!pagination &&
            <Pagination
              className="mb-0 justify-content-end"
              pagination={pagination}
              handleAction={(params) => {
                resetFilters();
                handleAction(params);
              }} />
          }
        </Col>
        <Col xs="auto" className="order-sm-3 order-4 me-2">
          {!!pagination && <PaginationDisplay pagination={pagination} />}
        </Col>
        <Col className="divider order-sm-3 order-1"></Col>
        <Col xs="auto" className="p-0 order-sm-3 order-4 ms-1 refresh" >
          <Button variant="icon"
            size="sm"
            data-tooltip-id="tb-tooltip" data-tooltip-content="Refresh"
            onClick={() => {
              resetFilters();
              handleAction({ actionType: DriveUIActionTypes.Refresh });
            }}
            title="Refresh Current Folder">
            {
              is_loading ?
                <i className="spinner"></i> :
                <Icon className="ficon-rotate-cw" />
            }
          </Button>
        </Col>
      </>
    }
  </Row>;
}

export default React.memo(ToolbarComponent);